// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".control-label[data-v-172fda62] {\n  font-size: 0.675rem;\n}\n.scale-reduce[data-v-172fda62] {\n  -webkit-transform: scale(0.725);\n          transform: scale(0.725);\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n}\n.downloadBtn[data-v-172fda62] {\n  margin: 0% 5% 0% 5%;\n}", ""]);
// Exports
module.exports = exports;
